










































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import Billing from "@/services/Billing";
import storeBilling from "@/store/modules/Billing";
@Component({})
export default class CardModalBatalAskepRanap extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() pasien!: object;
  @Prop() tgl!: string;
  @Prop() shift!: string;
  password = "";
  msg = "";
  cancel = false;
  showEye = false;
  rules = {
    required: (value) => !!value || "Required.",
  };

  get stateuser() {
    return userModule.user;
  }
  get show() {
    return this.value;
  }
  set show(value) {
    this.$emit("input", value);
  }

  formatTgl(date) {
    const [day, month, year] = date.split("-");
    return year + "-" + month + "-" + day;
  }

  batal() {
    const param = {
      tanggal: this.tgl,
      unit_id: this.stateuser.unit_id,
      rm: this.pasien["rm"],
      register_id: this.pasien["register"].no,
      shift: this.shift["id"],
      register_tgl: this.formatTgl(this.pasien["register"].tgl),
      auth: this.password,
    };
    if (!this.cancel) {
      this.cancel = true;
      const dt = Billing.deleteAskep(param);
      dt.then((dt) => {
        this.cancel = false;
        if (dt["status"] != 1) {
          // appModule.sendErrorAlert(dt["message"]);
          this.msg = dt["message"];
          this.cancel = false;
        } else {
          appModule.NoticeDelay("Berhasil Hapus/Batal Asuhan Keperawatan");
          this.$emit("suksesBatal");
          this.msg = "";
          this.show = false;
        }
      });
    }
  }

  close() {
    this.msg = "";
    this.show = false;
    this.password = "";
  }

  @Watch("value")
  changedValue(val) {
    if (!val) {
      this.password = "";
      this.msg = "";
    }
  }
}
